import React, { useRef } from 'react'
import { OverlayPanel } from 'primereact/overlaypanel'

import { Button } from '../../../helpers'
import Tooltip from '../../../helpers/Tooltip'

import { getDateString, getFullName } from '../../../utils'


const EditPIPunch = (props) => {
    const { handleSaveClick, sellerPIPunch, canEditable, usersData, handleEditClick, handleRaisePriority, handleSkipVerification, isLoaderVisible, relatedApprovalInstance } = props
    const op = useRef(null)

    const getEditHTML = (approvalInstance) => {
        const companyPMUsers = usersData.PMCompanyDetails.companyUsers
        let approverUser = null
        if (approvalInstance){
            approverUser = companyPMUsers.find(each => each.userId === approvalInstance.processedBy)
        }

        let approverName = ``
        if(approverUser){
            approverName = getFullName(approverUser.firstName, approverUser.lastName)
        }

        if (approvalInstance && approvalInstance.statusId === 12) {
            return <h4 className="align-self-center mr-2 mt-3">Approval Request is Pending</h4>
        }
        else {
            return (
                <>
                    {
                        approvalInstance && approvalInstance.statusId === 9 &&
                        <div className="flex flex-column m-0 pr-2">
                            <p className="m-0"><span className="font-semibold">Approved by manager:</span>{` ${approverName}`}</p>
                        </div>
                    }
                    <Button className={`mr-2 border-none ${sellerPIPunch.toggleInputs ? 'bg-yellow-600' : 'bg-teal-700'}`} disabled={forViewOnly || sellerPIPunch.statusId === 2 || !canEditable} permissions={canEditable ? [] : [22]} rounded onClick={handlePIPunchEditbtn}>
                        <i className={`pi ${sellerPIPunch.toggleInputs ? `pi-file-edit bg-yellow-600` : `pi-save bg-teal-700`} align-self-center`}></i>
                    </Button>
                </>
            )
        }
        }

    const handlePIPunchEdit = (e) => {
        op.current.toggle(e)
        handleEditClick(sellerPIPunch.sellerPIPunchId)
    }

    const handlePIPunchEditbtn = (e) => {
        if(sellerPIPunch.toggleInputs){
            op.current.toggle(e) 
        }
        else{
            handleSaveClick(sellerPIPunch.sellerPIPunchId)
        }
    }

    const priorityRaisedByDetails = usersData.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === sellerPIPunch.priorityRaisedBy)
    let priorityRaisedByName = ''
    if (priorityRaisedByDetails) {
        priorityRaisedByName = getFullName(priorityRaisedByDetails.firstName, priorityRaisedByDetails.lastName)
    }

    const skippedByDetails = usersData.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === sellerPIPunch.skippedBy)
    let skippedByName = ''
    if (skippedByDetails) {
        skippedByName = getFullName(skippedByDetails.firstName, skippedByDetails.lastName)
    }

    let forViewOnly = false
    if(props.forViewOnly){
        forViewOnly = props.forViewOnly
    }

    let raisePriorityDisableCond = forViewOnly || sellerPIPunch.priorityId === 1 || sellerPIPunch.statusId === 2 || sellerPIPunch.verifiedBy || isLoaderVisible
    let skipVerificationDisableCond = forViewOnly || sellerPIPunch.skippedBy || sellerPIPunch.statusId === 2 || sellerPIPunch.verifiedBy || isLoaderVisible

    let isPIVerified = false

    let permissions = []
    if (canEditable){
        permissions = [22]
    }

    if (sellerPIPunch.verifiedBy){
        isPIVerified = true
        permissions = [271]
    }

    return (
        <>
            {getEditHTML(relatedApprovalInstance)}

            <OverlayPanel ref={op} className="overlay-panel p-2 mt-3" style={{ minHeight: "3rem" }} closeOnEscape>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: 'center' }}>
                    {
                        sellerPIPunch.toggleInputs ?
                            <Button disabled={forViewOnly || sellerPIPunch.statusId === 2 || isLoaderVisible} label="Edit" text permissions={permissions} tooltip={isPIVerified ? "PI is already verified by payments team. Please reach out to your city-head or Central Ops team to update the document." : null} tooltipOptions={{ showOnDisabled: true }}  onClick={handlePIPunchEdit}></Button>
                            :
                            <Button disabled={forViewOnly || sellerPIPunch.statusId === 2 || isLoaderVisible} label="Save" text onClick={() => handleSaveClick(sellerPIPunch.sellerPIPunchId)}></Button>
                    }

                    <Button label="Raise Priority" className={`raise-priority-tooltip-${sellerPIPunch.sellerPIPunchId}`} disabled={raisePriorityDisableCond} text onClick={() => handleRaisePriority(sellerPIPunch)} permissions={[204]} />
                    {
                        (sellerPIPunch.priorityId === 1 && !sellerPIPunch.verifiedBy) &&
                        <Tooltip target={`.raise-priority-tooltip-${sellerPIPunch.sellerPIPunchId}`} showOnDisabled position="left">
                            <div className="flex flex-column m-0">
                                <p className="m-0"><span className="font-semibold">Priority Raised By:</span>{` ${priorityRaisedByName}`}</p>
                                <p className="m-0"><span className="font-semibold">Priority Raised At:</span>{` ${getDateString(sellerPIPunch.priorityRaisedAt, "DD.MM.YYYY hh:mm")}`}</p>
                            </div>
                        </Tooltip>
                    }

                    <Button label="Skip Verification" className={`skip-verification-tooltip-${sellerPIPunch.sellerPIPunchId}`} disabled={forViewOnly || sellerPIPunch.statusId === 2 || skipVerificationDisableCond || isLoaderVisible} text onClick={() => handleSkipVerification(sellerPIPunch)} permissions={[205]} />
                    {
                        skippedByName &&
                        <Tooltip target={`.skip-verification-tooltip-${sellerPIPunch.sellerPIPunchId}`} showOnDisabled position="left">
                            <div className="flex flex-column m-0">
                                <p className="m-0"><span className="font-semibold">Verification Skipped By:</span>{` ${skippedByName}`}</p>
                                <p className="m-0"><span className="font-semibold">Verification Skipped At:</span>{` ${getDateString(sellerPIPunch.skippedAt, "DD.MM.YYYY hh:mm")}`}</p>
                            </div>
                        </Tooltip>
                    }

                    <Button className="small-btn mb-1" label="Cancel" text onClick={e => op.current.toggle(e)} />
                </div>
            </OverlayPanel>
        </>
    )
}

export default EditPIPunch